import 'script-loader!node_modules/jquery/dist/jquery.min.js';
import 'script-loader!node_modules/slick-carousel/slick/slick.js';

export default class NearbyBranches {
  static init() {
    for (let el of document.querySelectorAll('.NearbyBranches')) {
      new NearbyBranches(el).updateCarousel();
    }

    if (!window.__nearbyBranchesResizeListenerAdded) {
      window.addEventListener('resize', () => {
        clearTimeout(window.__nearbyBranchesResizeTimer);
        window.__nearbyBranchesResizeTimer = setTimeout(() => {
          NearbyBranches.updateAll();
        }, 200);
      });
      window.__nearbyBranchesResizeListenerAdded = true;
    }
  }

  static updateAll() {
    for (let el of document.querySelectorAll('.NearbyBranches')) {
      const instance = new NearbyBranches(el);
      instance.updateCarousel();
    }
  }

  constructor(element) {
    this.element = element;
    this.wrapper = this.element.querySelector('.NearbyBranches-cardWrappers');
    this.$carousel = $(this.wrapper);
  }

  updateCarousel() {
    if (!this.wrapper) return;

    const visibleCards = Array.from(this.wrapper.querySelectorAll('.LocationCard'))
      .filter(card => card.offsetParent !== null && !card.classList.contains('is-permanently-closed'));

    const slidesPerPage = window.innerWidth <= 768 ? 2 : 4;
    const needsCarousel = visibleCards.length > slidesPerPage;

    if (this.$carousel.hasClass('slick-initialized')) {
      this.$carousel.slick('unslick');
    }

    this.wrapper.classList.remove('NearbyBranches-carousel');
    this.element.classList.remove('NearbyBranches-carouselWrapper');
    this.$carousel.find('.NearbyBranches-placeholder').remove();

    if (!needsCarousel) return;

    this.wrapper.classList.add('NearbyBranches-carousel');
    this.element.classList.add('NearbyBranches-carouselWrapper');

    const remainder = visibleCards.length % slidesPerPage;
    const needsPadding = visibleCards.length > slidesPerPage && remainder !== 0;

    if (needsPadding) {
      const fillers = slidesPerPage - remainder;
      for (let i = 0; i < fillers; i++) {
        const placeholder = document.createElement('div');
        placeholder.className = 'NearbyBranches-placeholder slick-slide';
        placeholder.setAttribute('aria-hidden', 'true');
        placeholder.setAttribute('tabindex', '-1');
        this.$carousel[0].appendChild(placeholder);
      }
    }

    this.$carousel.slick({
      slidesToShow: slidesPerPage,
      slidesToScroll: slidesPerPage,
      infinite: false,
      arrows: true,
      rows: 0,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  }
}
